import {Box, CardContent, ListItem, ListItemAvatar, ListItemText, Typography} from "@material-ui/core";
import {exist} from "../../../../common/utils/Util";
import {PhoneNumberDial} from "../../../../common/component/PhoneNumberDial";
import Avatar from "@material-ui/core/Avatar";
import {EmailClient} from "../../../../common/component/EmailClient";
import {Show} from "../../../../common/component/form/Show";
import React from "react";
import {Preprava} from "../../../model/Preprava";
import {Vozidlo} from "../../../model/Vozidlo";
import {useTranslation} from "react-i18next";
import {useEvaluateFieldsVisibility} from "../../../../common/logic/visibility-logic";
import {InzeratViewDetail} from "../../../model/Inzerat";
import Phone from "@material-ui/icons/Phone";
import {makeStyles} from "@material-ui/core/styles";
import {FlagIcon} from "../../../../common/component/FlagIcon";
import {Place} from "@material-ui/icons";
import {Firma} from "../../../model/Firma";

const useStyles = makeStyles((_theme) => ({
    root: {
        "& a": {
            fontSize: "16px",
        },
    },
}));

const KontaktDetail = ({name, title, phoneNumber, email, offerEmail, type, firma} : {name?: string, title?: string, phoneNumber?: string | string[], email?: string | string[], offerEmail?: string, type?: "rychlyKontakt" | "uzivatel" | "zadavatel" | "adresaFirmy", firma?: Firma,
}) => {
    const classes = useStyles();

    return (
        <CardContent style={{paddingBottom: 0}}>
            {type === "adresaFirmy" && firma &&
                <>
                    <Box display="flex" alignItems="center">
                            <Avatar className={"avatar-flag"}><FlagIcon mpz={firma.r1Stat}/></Avatar>
                        <Typography style={{paddingLeft: "8px"}} variant="h6">{title}</Typography>
                    </Box>
                    <ListItem style={{padding: 0, paddingLeft: "48px"}}>
                        <ListItemText primary={firma.r1Nazev ?? ''}/>
                    </ListItem>
                    <ListItem style={{padding: 0, paddingLeft: "48px"}}>
                        <ListItemText primary={`${firma.r1Ulice ?? ''} ${firma.r1CisloPopisne ?? ''}`}/>
                    </ListItem>
                    <ListItem style={{padding: 0, paddingLeft: "48px"}}>
                        <ListItemText primary={`${firma.r1Psc ?? ''} ${firma.r1Obec ?? ''}`}/>
                    </ListItem>
                </>
            }
            {type === "rychlyKontakt" &&
                <Box display="flex" alignItems="center">
                    <Avatar className="avatar-contact">
                        <Phone />
                    </Avatar>
                    <Typography style={{paddingLeft: "8px"}} variant="h6">{title}</Typography>
                </Box>
            }
            {(type === "uzivatel" || type === "zadavatel") &&
                <Box display="flex" alignItems="center">
                    <Avatar className="avatar-contact"></Avatar>
                    <Typography style={{paddingLeft: "8px"}} variant="h6">{title}</Typography>
                </Box>
            }
            {name && <ListItem style={{padding: 0, paddingLeft: "48px"}}>
                <ListItemText primary={name}/>
            </ListItem>}
            {phoneNumber ? phoneNumber instanceof Array ?
                phoneNumber.map((n: string, i) => (
                <ListItem className={classes.root} style={{padding: 0, paddingLeft: "48px"}} key={i}>
                    <PhoneNumberDial hideIcon={true} phoneNumber={n}/>
                </ListItem>)) :
                <ListItem className={classes.root} style={{padding: 0, paddingLeft: "48px"}}>
                    <PhoneNumberDial hideIcon={true} phoneNumber={phoneNumber}/>
                </ListItem> :
                null
            }
            {offerEmail && <ListItem className={classes.root} style={{padding: 0, paddingLeft: "48px"}}>
                <EmailClient hideIcon={true} emailAddress={offerEmail}/>
            </ListItem>}
            {email ? email instanceof Array ? email.map((e: string, i) => (
                    <ListItem className={classes.root} style={{padding: 0, paddingLeft: "48px"}} key={i}>
                        <EmailClient hideIcon={true} emailAddress={e}/>

                    </ListItem>)) :
                <ListItem className={classes.root} style={{padding: 0, paddingLeft: "48px"}}>
                    <EmailClient hideIcon={true} emailAddress={email}/>
                </ListItem> :
                null
            }
        </CardContent>
    )
}

export const KontaktyView = (props:{data:Preprava|Vozidlo|InzeratViewDetail, admin:boolean}) => {
    const {t} = useTranslation();
    const ev = useEvaluateFieldsVisibility(props.data.uzivatel?.provozovna, props.data.uzivatel?.provozovna?.firma, props.admin);

    const rychlyKontakt = exist(props.data.rychlyKontakt) || exist(props.data.email);
    const zadavatel = exist(props.data.uzivatel?.jmeno);
    const dispecer = exist(props.data.dispecer?.id);
    const adresaFirmy = exist(props.data.uzivatel?.provozovna.firma)

    if (!rychlyKontakt && !dispecer && !zadavatel) {
        return (
            <Show visible={ev(["provozovna.email", "provozovna.telCislaKontaktu"])}>
                <KontaktDetail
                    title={t("Provozovna.OtherInfo")}
                    phoneNumber={props.data.uzivatel.provozovna.telCislaKontaktu}
                    email={props.data.uzivatel.provozovna.emaily}  />
            </Show>
        )
    }

    return (
        <>
            {adresaFirmy ? <KontaktDetail
                                title={t("Provozovna.CompanyContactLabel")}
                                type={"adresaFirmy"}
                                firma={props.data.uzivatel.provozovna.firma}/> : null}

            {rychlyKontakt ? <KontaktDetail
                                title={t("Default.QuickContact")}
                                phoneNumber={props.data.rychlyKontakt}
                                offerEmail={props.data.email}
                                type={"rychlyKontakt"}/> : null}
            {dispecer ? <KontaktDetail
                                title={t("Preprava.dispecer")}
                                phoneNumber={props.data.dispecer.phoneNumbers}
                                email={props.data.dispecer.email}
                                name={props.data.dispecer.jmeno}
                                type={"uzivatel"}/> : null}
            {(zadavatel && !dispecer) ? <KontaktDetail
                                title={t("User.View")}
                                phoneNumber={props.data.uzivatel.phoneNumbers}
                                email={props.data.uzivatel.email}
                                name={props.data.uzivatel.jmeno}
                                type={"zadavatel"}/> : null}
        </>
    )
}
